import { ErrorTypes } from 'interfaces/auth.types';
import { ActionType } from 'interfaces/actions.types';
import {
  action,
  createRequestTypes,
  FAILURE,
  REQUEST,
  RequestTypes,
  SUCCESS,
} from 'services/api';
import { BadgeType, LoadingStatusType } from 'interfaces';

export const BADGE_USER_DETAILS: RequestTypes =
  createRequestTypes('BADGE_USER_DETAILS');
export const SET_BADGE_USER_DETAILS_STATUS = 'SET_BADGE_USER_DETAILS_STATUS';

export const badgeUserDetails = {
  request: ({ id }: { id: string | number }): ActionType =>
    action(BADGE_USER_DETAILS[REQUEST], { id }),
  success: ({
    id,
    badge,
  }: {
    id: string | number;
    badge: BadgeType;
  }): ActionType => action(BADGE_USER_DETAILS[SUCCESS], { id, badge }),
  failure: ({
    id,
    error,
  }: {
    id: string | number;
    error: ErrorTypes;
  }): ActionType => action(BADGE_USER_DETAILS[FAILURE], { id, error }),
};

export const setBadgeUserDetailsStatus = (
  id: string | number,
  status: LoadingStatusType,
): ActionType => action(SET_BADGE_USER_DETAILS_STATUS, { id, status });
